import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EventEmitter from 'eventemitter3';
import { Scrollbar } from 'react-scrollbars-custom';
import { ESCAPE, UP, DOWN, TAB } from '../constants/keys';
import { withStyles } from '../theme';
import { getBoundingClientRect } from '../utils/DOM';
import { isolateMixin } from '../utils/mixins';
import { MenuContext } from './context';
var emptyArr = [];

var styles = function styles(theme) {
  return {
    menu: {
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      boxSizing: 'border-box',
      padding: 0,
      borderRadius: theme.menu.borderRadius
    },
    scrollbar: {
      position: 'relative',
      width: '100%',
      height: '100%',
      borderRadius: theme.menu.borderRadius,
      transform: 'translate3d(0, 0, 0)'
    },
    scrollbarInner: {
      position: 'relative',
      height: '100%'
    },
    content: {
      display: 'block'
    },
    scrollbarTrack: {
      width: '6px !important',
      right: "".concat(theme.menu.scrollMargin, "px !important"),
      top: "".concat(Math.max(theme.menu.scrollMargin, theme.menu.borderRadius - 5), "px !important"),
      height: "calc(100% - ".concat(2 * Math.max(theme.menu.scrollMargin, theme.menu.borderRadius - 5), "px) !important"),
      borderRadius: "".concat(theme.menu.borderRadius, "px !important"),
      backgroundColor: 'transparent !important'
    },
    scrollbarThumb: {
      width: '6px !important',
      borderRadius: "".concat(theme.menu.borderRadius, "px !important"),
      backgroundColor: "".concat(theme.menu.colors.default.thumb, " !important")
    }
  };
};

var Menu = /*#__PURE__*/function (_PureComponent) {
  _inherits(Menu, _PureComponent);

  var _super = _createSuper(Menu);

  function Menu() {
    var _this;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.value = _this.props.multiple ? Array.isArray(_this.props.value) ? _this.props.value : emptyArr : _this.props.value;
    _this.state = {
      value: _this.value
    };
    _this.focusIndex = -1;
    _this.itemsKeys = [];
    _this.itemsRefs = {};
    _this.registeredItems = {};

    _this.addItem = function (key, ref) {
      _this.registeredItems[key] = ref;
    };

    _this.removeItem = function (key) {
      delete _this.registeredItems[key];
    };

    _this.isValueSelected = function (value) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (props.multiple) {
        var selected = Array.isArray(_this.value) ? _this.value : emptyArr;
        return selected.some(function (item) {
          return props.valuesEquality(item, value);
        });
      } else {
        return props.valuesEquality(_this.value, value);
      }
    };

    _this.isItemFocused = function (key) {
      var index = _this.itemsKeys.indexOf(key);

      return index > -1 ? index === _this.focusIndex : false;
    };

    _this.isMenuDisabled = function () {
      return _this.props.disabled;
    };

    _this.getMenuSize = function () {
      return _this.props.size;
    };

    _this.getItemRef = function (key) {
      return _this.itemsRefs[key];
    };

    _this.handleOptionFocus = function (key) {
      var index = _this.itemsKeys.indexOf(key);

      if (index === -1) return;

      _this.setFocusByIndex(index);
    };

    _this.handleOptionSelect = function (value) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          props = _assertThisInitialize2.props;

      var nextValue;

      if (props.multiple) {
        var currValue = Array.isArray(_this.value) ? _this.value : emptyArr;
        var withoutValue = currValue.filter(function (v) {
          return !props.valuesEquality(v, value);
        });
        nextValue = withoutValue.length === currValue.length ? currValue.concat(value) : withoutValue;
      } else {
        nextValue = value;
      }

      _this.setValue(nextValue);

      props.onChange(nextValue);
    };

    _this.keyDown = function (event) {
      var key = event.keyCode;
      var shift = event.shiftKey;

      if (key === ESCAPE) {
        _this.props.onEscKeyDown(event);
      } else if (key === UP || key === TAB && shift) {
        event.preventDefault();

        _this.decrementFocusIndex();
      } else if (key === DOWN || key === TAB && !shift) {
        event.preventDefault();

        _this.incrementFocusIndex();
      }
    };

    _this.handleBlur = function () {
      _this.focusIndex = -1;
    };

    _this.saveMenuRef = function (ref) {
      _this.menu = ref;
      if (_this.props.nodeRef) _this.props.nodeRef(ref);
    };

    return _this;
  }

  _createClass(Menu, [{
    key: "updateItemsKeys",
    value: function updateItemsKeys() {
      var nodes = this.menu.querySelectorAll('[data-menu-item-id]');
      var refs = {};
      this.itemsKeys = Array.prototype.slice.call(nodes).map(function (node) {
        var key = node.getAttribute('data-menu-item-id');
        refs[key] = node;
        return key;
      });
      this.itemsRefs = refs;
    }
  }, {
    key: "createEvents",
    value: function createEvents() {
      this.events = new EventEmitter();
      this.events.on('onItemSelect', this.handleOptionSelect);
      this.events.on('onItemFocus', this.handleOptionFocus);
      this.events.on('onItemMount', this.addItem);
      this.events.on('onItemUnmount', this.removeItem);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateItemsKeys();
      this.scrollToLastSelected();
      if (this.props.autoFocus) this.setAutoFocus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var props = this.props;
      this.updateItemsKeys();
      this.setValue(props.value);
      if (props.disabled !== prevProps.disabled || props.size !== prevProps.size || props.value !== prevState.value) this.events.emit('onPropsChange');
      if (props.autoFocus && !prevProps.autoFocus) this.setAutoFocus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.events) this.events.removeAllListeners();
    }
  }, {
    key: "scrollToLastSelected",
    value: function scrollToLastSelected() {
      var lastSelectedIndex = this.getLastSelectedIndex();
      if (lastSelectedIndex === -1) return;
      var item = this.itemsRefs[this.itemsKeys[lastSelectedIndex]];
      if (!item) return;
      var menuRect = getBoundingClientRect(this.menu);
      var itemRect = getBoundingClientRect(item);
      this.menu.scrollTop += itemRect.top - menuRect.top - menuRect.height / 2;
    }
  }, {
    key: "setAutoFocus",
    value: function setAutoFocus() {
      var lastSelectedIndex = this.getLastSelectedIndex();
      var newIndex = lastSelectedIndex > -1 ? lastSelectedIndex : 0;
      this.setFocusByIndex(newIndex);
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this2 = this;

      if (this.props.multiple) {
        var currValue = Array.isArray(this.value) ? this.value : emptyArr;
        var nextValue = Array.isArray(value) ? value : emptyArr;
        if (nextValue.length === currValue.length && nextValue.every(function (item, index) {
          return _this2.props.valuesEquality(item, currValue[index]);
        })) return;
      } else {
        if (this.props.valuesEquality(value, this.value)) return;
      }

      this.value = value;
      this.setState({
        value: value
      });
    }
  }, {
    key: "getLastSelectedIndex",
    value: function getLastSelectedIndex() {
      var _this3 = this;

      return this.itemsKeys.reduceRight(function (result, key, index) {
        return result === -1 && _this3.registeredItems[key].isSelected ? index : result;
      }, -1);
    }
  }, {
    key: "decrementFocusIndex",
    value: function decrementFocusIndex() {
      var maxIndex = this.itemsKeys.length - 1;
      this.setFocusByIndex(this.focusIndex <= 0 ? maxIndex : this.focusIndex - 1);
    }
  }, {
    key: "incrementFocusIndex",
    value: function incrementFocusIndex() {
      var maxIndex = this.itemsKeys.length - 1;
      this.setFocusByIndex(this.focusIndex >= maxIndex ? 0 : this.focusIndex + 1);
    }
  }, {
    key: "setFocusByIndex",
    value: function setFocusByIndex(focusIndex) {
      if (focusIndex === this.focusIndex) return;
      this.focusIndex = focusIndex;
      this.events.emit('onPropsChange');
    }
  }, {
    key: "getMenuProps",
    value: function getMenuProps() {
      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          value = _this$props.value,
          theme = _this$props.theme,
          onChange = _this$props.onChange,
          onEscKeyDown = _this$props.onEscKeyDown,
          multiple = _this$props.multiple,
          valuesEquality = _this$props.valuesEquality,
          disabled = _this$props.disabled,
          size = _this$props.size,
          itemClassName = _this$props.itemClassName,
          nodeRef = _this$props.nodeRef,
          props = _objectWithoutProperties(_this$props, ["autoFocus", "value", "theme", "onChange", "onEscKeyDown", "multiple", "valuesEquality", "disabled", "size", "itemClassName", "nodeRef"]);
      /* eslint-enable no-unused-vars */


      return props;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getMenuProps = this.getMenuProps(),
          className = _this$getMenuProps.className,
          style = _this$getMenuProps.style,
          maxHeight = _this$getMenuProps.maxHeight,
          children = _this$getMenuProps.children,
          classes = _this$getMenuProps.classes,
          scrollRef = _this$getMenuProps.scrollRef,
          other = _objectWithoutProperties(_this$getMenuProps, ["className", "style", "maxHeight", "children", "classes", "scrollRef"]);

      return React.createElement(MenuContext.Provider, {
        value: this.contextValue
      }, React.createElement(Scrollbar, _extends({}, other, {
        ref: scrollRef,
        elementRef: this.saveMenuRef,
        style: _extends({
          maxHeight: maxHeight
        }, style),
        onKeyDown: this.keyDown,
        onBlur: this.handleBlur,
        translateContentSizeYToHolder: true,
        removeTracksWhenNotUsed: true,
        renderer: function renderer(_ref) {
          var elementRef = _ref.elementRef,
              props = _objectWithoutProperties(_ref, ["elementRef"]);

          return React.createElement("div", _extends({}, props, {
            ref: elementRef,
            className: classnames(classes.menu, className)
          }));
        },
        contentProps: {
          renderer: function renderer(_ref2) {
            var elementRef = _ref2.elementRef,
                style = _ref2.style,
                props = _objectWithoutProperties(_ref2, ["elementRef", "style"]);

            return React.createElement("div", _extends({}, props, {
              ref: elementRef,
              className: classes.content,
              style: _extends({}, style, {
                display: null
              })
            }));
          }
        },
        wrapperProps: {
          renderer: function renderer(_ref3) {
            var elementRef = _ref3.elementRef,
                style = _ref3.style,
                props = _objectWithoutProperties(_ref3, ["elementRef", "style"]);

            return React.createElement("div", _extends({}, props, {
              ref: elementRef,
              className: classes.scrollbar,
              style: _extends({}, style, {
                position: null,
                width: null
              })
            }));
          }
        },
        scrollerProps: {
          renderer: function renderer(_ref4) {
            var elementRef = _ref4.elementRef,
                style = _ref4.style,
                props = _objectWithoutProperties(_ref4, ["elementRef", "style"]);

            return React.createElement("div", _extends({}, props, {
              ref: elementRef,
              className: classes.scrollbarInner,
              style: _extends({}, style, {
                position: null
              })
            }));
          }
        },
        trackYProps: {
          renderer: function renderer(_ref5) {
            var elementRef = _ref5.elementRef,
                props = _objectWithoutProperties(_ref5, ["elementRef"]);

            return React.createElement("div", _extends({}, props, {
              ref: elementRef,
              className: classes.scrollbarTrack
            }));
          }
        },
        thumbYProps: {
          renderer: function renderer(_ref6) {
            var elementRef = _ref6.elementRef,
                props = _objectWithoutProperties(_ref6, ["elementRef"]);

            return React.createElement("div", _extends({}, props, {
              ref: elementRef,
              className: classes.scrollbarThumb
            }));
          }
        }
      }), children));
    }
  }, {
    key: "contextValue",
    get: function get() {
      if (!this.events) this.createEvents();
      return {
        isValueSelected: this.isValueSelected,
        isItemFocused: this.isItemFocused,
        isMenuDisabled: this.isMenuDisabled,
        getMenuSize: this.getMenuSize,
        getItemRef: this.getItemRef,
        events: this.events,
        className: this.props.itemClassName
      };
    }
  }]);

  return Menu;
}(PureComponent);

Menu.defaultProps = {
  multiple: false,
  disabled: false,
  autoFocus: false,
  maxHeight: null,
  valuesEquality: function valuesEquality(a, b) {
    return a === b;
  },
  onChange: function onChange() {},
  onEscKeyDown: function onEscKeyDown() {},
  size: 'medium'
};
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Дополнительный CSS-класс поля
   */
  className: PropTypes.string,

  /**
   * Inline-стили поля
   */
  style: PropTypes.object,

  /**
   * Дополнительный CSS-класс элемента
   */
  itemClassName: PropTypes.string,

  /**
   * Множественный выбор
   */
  multiple: PropTypes.bool,

  /**
   * Опции не активны
   */
  disabled: PropTypes.bool,

  /**
   * Автофокус первого/выбранного элемента
   */
  autoFocus: PropTypes.bool,

  /**
   * Максимальная высота компонента
   */
  maxHeight: PropTypes.number,

  /**
   * Выбранное значение, по-умолчанию считается, что это примитив. В случае множественного выбора - массив выбранных значений.
   */
  value: PropTypes.any,

  /**
   * Проверка равенства значений, задается, если
   * значением является объект. Ожидается, что возвращает `Boolean`
   */
  valuesEquality: PropTypes.func,

  /**
   * Опции поля
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),

  /**
   * Коллбек, вызывающийся при изменении состояния
   */
  onChange: PropTypes.func,

  /**
   * Коллбек, вызывающийся при клике на `Escape`
   */
  onEscKeyDown: PropTypes.func,

  /**
   * Размер опций
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Коллбэк для передачи ссылки на ноду элемента кнопки
   */
  nodeRef: PropTypes.func,

  /**
   * Коллбэк для передачи ссылки на инстанс скролла
   */
  scrollRef: PropTypes.func
} : {};
export default withStyles(styles, {
  name: 'Menu'
})(Menu);